import {LIMPAR_RESERVAS_ITINERARIO} from '../types';

export default function limparReservasItinerario () {
    return {
        type: LIMPAR_RESERVAS_ITINERARIO
    }
}
